import { useAppDispatch, useAppSelector } from '@shared/hooks';
import { noteEditorActions } from './nodeEditorSlice';
import { type LineState } from './types';

export const useNoteTools = () => {
  const dispatch = useAppDispatch();
  const isOpenTools = useAppSelector((state) => state.noteEditor.isOpenTools);
  const isVisibleTools = useAppSelector((state) => state.noteEditor.isVisibleTools);
  const isUrlModalOpen = useAppSelector((state) => state.noteEditor.isUrlModalOpen);
  const editState = useAppSelector((state) => state.noteEditor.editState);

  const switchOpenTools = () => dispatch(noteEditorActions.toggleOpenTools());
  const setVisibleTools = (isVisible: boolean) => {
    dispatch(noteEditorActions.setVisibleTools(isVisible));
  };
  const setUrlModalOpen = (isVisible: boolean) => {
    dispatch(noteEditorActions.setUrlModalOpen(isVisible));
  };
  const setEditState = (state: LineState) => dispatch(noteEditorActions.setEditState(state));

  return {
    isOpenTools,
    isVisibleTools,
    editState,
    isUrlModalOpen,
    setUrlModalOpen,
    switchOpenTools,
    setVisibleTools,
    setEditState,
  };
};
